import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path1/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path1/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/aos/dist/aos.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/styles-light.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Lato\",\"arguments\":[{\"weight\":[\"100\",\"300\",\"400\",\"700\",\"900\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"font\"}");
